document.addEventListener("DOMContentLoaded", async () => {

    const title = document.getElementById("appointment-title");
    const date = document.getElementById("appointment-date");
    const time = document.getElementById("appointment-time");
    const duration = document.getElementById("appointment-duration");
    const status = document.getElementById("appointment-status");

    if (!title) return;

const customerEmail = window.skinformCustomer?.email;

console.log("Customer email:", customerEmail);

    if (!customerEmail) {

        title.textContent = "No customer";

        return;

    }

    try {

        const response = await fetch(

            "https://app.cowlendar.com/public-api/v1/bookings?" +

            new URLSearchParams({

                customer_email: customerEmail,

                status: "confirmed",

                limit: 1,

                sort: "start_date"

            }),

            {

headers: {

    Authorization: "Bearer cow_RYgYxes-jnE1NMCyIfHGCblT00KSx9DkZj0ar80eYlM",

    Accept: "application/json"

}

            }

        );

        if (!response.ok) {

            throw new Error("API Error");

        }

        const json = await response.json();

        console.log(json);

        if (!json.data || json.data.length === 0) {

            title.textContent = "No upcoming appointment";

            date.textContent = "--";

            time.textContent = "--";

            duration.textContent = "--";

            status.textContent = "--";

            return;

        }

        const booking = json.data[0];

        title.textContent = booking.service.title;

        const start = new Date(booking.start_date);

        const end = new Date(booking.end_date);

        const minutes = Math.round((end - start) / 60000);

        date.textContent = start.toLocaleDateString("en-US", {

            weekday: "long",

            month: "long",

            day: "numeric"

        });

        time.textContent = start.toLocaleTimeString("en-US", {

            hour: "numeric",

            minute: "2-digit"

        });

        duration.textContent = minutes + " Minutes";

        status.textContent = booking.confirmation_status
            .replace("_", " ")
            .replace(/\b\w/g, l => l.toUpperCase());

        if (booking.confirmation_status === "confirmed") {

            status.style.color = "#2E7D32";

        }

        if (booking.confirmation_status === "pending") {

            status.style.color = "#C68B00";

        }

        if (booking.confirmation_status === "cancelled") {

            status.style.color = "#C62828";

        }

        console.log("Booking", booking);

    }

    catch (error) {

        console.error(error);

        title.textContent = "Unable to load appointment";

        date.textContent = "--";

        time.textContent = "--";

        duration.textContent = "--";

        status.textContent = "--";

    }

});